<template>
  <tk-modal
    v-if="show"
    modal-size="lg"
    no-close-on-esc
    no-close-on-backdrop
    no-sp-fullscreen
    no-show-header
    style="padding-right: 0px;"
    @close="close"
  >
    <div class="modal-header">
      <button type="button" class="close" @click="close">
        <span>&times;</span>
      </button>
      <h3 class="modal-title room-detail"><strong>部屋の詳細</strong></h3>
    </div>
    <div class="modal-content-layout">
      <div class="modal-content-layout-image">
        <tk-image
          :image-path="image"
          class="tourHotelSelectRoom_reserve-hotelImage"
          @error="setAltImage"
        />
      </div>
      <div class="modal-content-layout-text">
        <template
          v-if="detailDescription && Object.keys(detailDescription).length > 0"
        >
          <h3 class="text-center pdt30 room-detail">
            <!-- eslint-disable vue/no-v-html -->
            <strong v-html="detailDescription.room_type" />
            <!--eslint-enable-->
          </h3>
          <p
            v-for="(facility, idx) in detailDescription.room_facility"
            :key="`detail-description${idx}`"
            class="room-detail-description"
          >
            <b>{{ facility.title }}</b>
            <br />
            {{ facility.description || '' }}
          </p>
        </template>
      </div>
    </div>
    <div class="Price_back2 pd10 width100Rest sp_dpb" style="clear: both;">
      <div class="row">
        <div class="w50p mglrauto">
          <p>
            <a class="btn btn-block btn-Green" @click="close">閉じる</a>
          </p>
        </div>
      </div>
    </div>
  </tk-modal>
</template>

<script>
import noImage from '@ota-frontend/shared-assets/images/common/noimage.jpg'
import TkModal from '../../atoms/TkGlobalModal/TkGlobalModal'
import TkImage from '../../atoms/TkImage/TkImage'

export default {
  name: 'PlanDetailModal',
  components: {
    TkImage,
    TkModal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    image: {
      type: String,
      default: null,
    },
    detailDescription: {
      type: [Array, Object],
      default: () => [],
    },
  },
  methods: {
    setAltImage(event) {
      event.target.src = noImage
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
